export default "__VITE_ASSET__Da2t2RIz__"